import React from 'react';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { CardBox, Button } from '../components/UI';
import { IconHome, IconSearch } from '@tabler/icons-react';

const NotFound = () => {
  const navigate = useNavigate();
  const { t } = useTranslation();

  return (
    <div className="min-h-screen bg-gray-50 dark:bg-[#171717] flex items-center justify-center px-4 py-12">
      <CardBox className="max-w-md w-full text-center">
        {/* 404 Illustration */}
        <div className="mb-8">
          <div className="relative inline-block">
            <div className="text-9xl font-bold text-gray-200 dark:text-[#2e2e2e]">404</div>
            <div className="absolute inset-0 flex items-center justify-center">
              <IconSearch size={64} className="text-primary opacity-80" />
            </div>
          </div>
        </div>

        {/* Error Message */}
        <h1 className="text-3xl font-bold text-gray-900 dark:text-[#f5f5f5] mb-4">
          {t('errors.notFound.title') || 'Page Not Found'}
        </h1>

        <p className="text-gray-600 dark:text-[#c4c4c4] mb-8 max-w-sm mx-auto">
          {t('errors.notFound.message') ||
            'The page you are looking for might have been removed, had its name changed, or is temporarily unavailable.'}
        </p>

        {/* Action Buttons */}
        <div className="space-y-3">
          <Button
            onClick={() => navigate('/')}
            leftIcon={<IconHome size={18} />}
            fullWidth
          >
            {t('errors.notFound.goHome') || 'Go to Homepage'}
          </Button>

          <Button
            onClick={() => navigate(-1)}
            variant="ghost"
            fullWidth
          >
            {t('errors.notFound.goBack') || 'Go Back'}
          </Button>
        </div>

        {/* Help Text */}
        <p className="mt-8 text-sm text-gray-500 dark:text-[#999999]">
          {t('errors.notFound.helpText') || 'If you believe this is an error, please contact support.'}
        </p>
      </CardBox>
    </div>
  );
};

export default NotFound;